















































import { Component, Prop, Mixins } from 'vue-property-decorator';
import DateMethods from '@/mixins/DateMethods.vue';
import { Actions } from '@/ts/store/Constants';
import ProfileImage from '@/components/Media/ProfileImage.vue';

@Component({
    name: 'EventCardImage',
    components: {
        ProfileImage,
    },
})
export default class EventCardImage extends Mixins(DateMethods) {
    @Prop({ required: true }) public id: number;
    @Prop({ default: () => [] }) public attendees: any;
    @Prop({ default: '' }) public date: string;
    @Prop({ default: '' }) public price: string;

    constructor() {
        super();
    }

    get media() {
        return this.$store.getters['Notifications/getNotificationMedia'](this.id);
    }

    public fetchNotificationMedia() {
        this.$store.dispatch(Actions.FETCH_NOTIFICATION_MEDIA_FOR_USER, this.id);
    }

    public created() {
        this.fetchNotificationMedia();
    }
}
